import React, {  useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { FiEdit } from "react-icons/fi";
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, notification, Spin } from "antd";
import { api } from "../../api/request.js";
import { endpoint } from "../../api/endpoint.js";

const DeviceParameters = ({ isVirtualDevice, isLoading, data, device, getDevice, getDeviceParameters }) => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [singleDeviceParameter, setSingleDeviceParameter] = useState({});
  const [parameters, setParameters] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
    setLoading(false);
  };
  const getParameters = async () => {
    const response = await axios.get(`/system-parameter`, { withCredentials: true });
    if (response) {
      setParameters(response.data.results);
    }
  };
  useEffect(() => {
    getParameters();
  }, []);

  const columns = [
    {
      name: "No.",
      cell: (_, index) => <div>{(page - 1) * limit + index + 1}</div>,
      selector: (row) => console.log(row),
      width: "60px",
    },
    {
      name: "Device Parameter Name",
      cell: (row) => <div className="text-capitalize">{row?.name}</div>,
      selector: (row) => row?.name,
    },
    ...(isVirtualDevice
      ? [
          {
            name: "Device Name",
            cell: (row) => <div className="text-capitalize">{row?.device?.name}</div>,
          },
        ]
      : []),

    {
      name: "System Parameter Name",
      cell: (row) => <div className="text-capitalize">{row?.systemParameter?.name || "--"}</div>,
      selector: (row) => row?._id,
      // center: true,
    },
    {
      name: "Count",
      selector: (row) => row?.count,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            className="btn btn-info me-1"
            onClick={() => {
              setIsModalOpen(true);
              setSingleDeviceParameter({
                ...row,
                systemParameterId: row?.systemParameter?._id,
              });
            }}
          >
            <FiEdit />
          </button>
          {/* {device?.parameter === row?._id ? (
            <button className="btn btn-warning">
              <AiFillStar />
            </button>
          ) : (
            <button className="btn btn-warning" onClick={() => setParameter(row?._id)}>
              <BiStar />
            </button>
          )} */}
        </div>
      ),
      right: "yes",
    },
  ];

  // const setParameter = async (parameter) => {
  //   let data = {
  //     parameter: parameter,
  //   };
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You want to set this parameter as default?",
  //     //icon: "warning",
  //     dangerMode: true,
  //     showCancelButton: true,
  //     confirmButtonText: "Confirm",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .put(`/device/` + device._id, data, {
  //           withCredentials: true,
  //         })
  //         .then((res) => {
  //           getDevice();
  //           getDeviceParameters();
  //           Swal.fire({
  //             title: "Done!",
  //             text: "Set default parameter Successfully",
  //             icon: "success",
  //             timer: 2000,
  //             button: false,
  //           });
  //         });
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //     }
  //   });
  // };

  const onAssingSystemParaToDevicePara = async () => {
    try {
      const { message } = await api.post(endpoint.assing_system_parameter, {
        systemParameterId: singleDeviceParameter?.systemParameterId,
        deviceParameterId: singleDeviceParameter?._id,
      });
      notification.info({
        message,
        placement: "bottomLeft",
      });
      setIsModalOpen(false);
      getDeviceParameters();
    } catch (error) {
      console.log(error?.response);
      notification.warning({
        message: error?.response?.data?.message,
        placement: "bottomLeft",
      });
    }
  };

  return (
    <div>
      <h4 className="mb-3">Available Device Parameters</h4>
      <Modal
        title={`Assign System Parameter Name - ${singleDeviceParameter?.name}`}
        open={isModalOpen}
        onOk={onAssingSystemParaToDevicePara}
        onCancel={handleCancel}
        okButtonProps={{
          className: "btn btn-success h-auto",
          loading,
        }}
        cancelButtonProps={{ className: "btn btn-secondary h-auto" }}
      >
        <select
          className="form-select"
          name="interval"
          value={singleDeviceParameter?.systemParameterId}
          onChange={(e) =>
            setSingleDeviceParameter({
              ...singleDeviceParameter,
              systemParameterId: e.target.value,
            })
          }
        >
          <option value="">Select system parameter</option>
          {parameters.map(({ _id, name }) => (
            <option value={_id} key={_id}>
              {name}
            </option>
          ))}
        </select>
      </Modal>
      <Spin spinning={isLoading}>
        <DataTable
          columns={columns}
          data={data}
          pagination
          paginationPerPage={limit}
          onChangePage={(data) => setPage(data)}
          onChangeRowsPerPage={(data) => {
            setLimit(data);
            setPage(1);
          }}
          paginationRowsPerPageOptions={[10, 20, 50]}
        />
      </Spin>
    </div>
  );
};

export default DeviceParameters;
